/**
 * Twilio address prefix used for WhatsApp participants (e.g.
 * `whatsapp:+61400000000`). Mirrors the agent-side helper in
 * `jira/src/packages/customer-service/live-conversations-issue-view` so the
 * help-center widget and the Jira agent view classify WhatsApp authors
 * identically. The two products cannot share code directly, so the logic is
 * intentionally duplicated and kept in sync.
 */
export const WHATSAPP_PREFIX = 'whatsapp:';

// `whatsapp:` followed by an E.164 phone number (leading `+`, first digit
// 1-9, then up to 14 more digits).
const WHATSAPP_AUTHOR_REGEX = new RegExp(`^${WHATSAPP_PREFIX}\\+[1-9]\\d{1,14}$`);

/**
 * Returns true when `author` is a WhatsApp participant address. A WhatsApp
 * help-seeker chats from their phone, so their Twilio message `author` is the
 * `whatsapp:<E.164>` address rather than the widget's Twilio client identity.
 */
export const isWhatsAppAuthor = (author: string | null | undefined): author is string =>
	!!author && WHATSAPP_AUTHOR_REGEX.test(author);
